var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"notification-banner",class:{
    'notification-banner--info': _vm.type === _vm.notificationType.INFO,
    'notification-banner--success': _vm.type === _vm.notificationType.SUCCESS,
    'notification-banner--error': _vm.type === _vm.notificationType.ERROR }},[_c('div',{staticClass:"notification-banner__message"},[_vm._v("\n    "+_vm._s(_vm.message)+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"notification-banner__close",on:{"click":function($event){return _vm.$store.dispatch('disableNotificationMessage', _vm.notificationId)}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }